import { palette } from "../palette";
export const ticket = {
  callOut: palette.teal.primary,
  divider: {
    default: palette.orange.lighter,
    secondary: palette.purple.lighter
  }
};